import stage_config from './stage_config.js';
import app_config from './app_config.js'; // prod
// import sandbox_config from './sandbox_config.js';
console.log('ENVIRONMENT =', process.env.REACT_APP_ENV);

// eslint-disable-next-line import/no-mutable-exports
let config = '';

if (process.env.REACT_APP_ENV === 'app') {
  config = app_config;
} else if (process.env.REACT_APP_ENV === 'stage') {
  config = stage_config;
} else {
  config = stage_config;
}

export default config;



// WEBPACK FOOTER //
// ./src/utils/config.js